import {ApisauceInstance} from 'apisauce';

// Url
import {url} from '../api.url';

const products = (api: ApisauceInstance) => {
  const getProductsDictionary = () => api.get(url.getProductsDictionary);
  const getProductDrugInfoById = (id: string) => api.get(url.getProductDrugInfoById(id));

  const getChemicalProbes = () => api.get(url.chemicalProbes);

  return {
    getChemicalProbes,
    getProductsDictionary,
    getProductDrugInfoById,
  };
};

export default products;
